import { useState, type JSX } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "staysure-component-library";

import Styles from "./expand-title.module.css";

interface Props {
  brand: "staysure" | "avanti";
  title: string | null;
  initShow?: boolean;
  setIsShow: (isOpen: boolean) => void;
  id?: string;
}

function ExpandTitle({
  title,
  setIsShow,
  initShow = false,
  id = "expand-title",
  brand,
}: Readonly<Props>): JSX.Element {
  const [isOpen, setIsOpen] = useState(initShow);

  const toggle = (event: React.MouseEvent<HTMLButtonElement>) => {
    setIsShow(isOpen);
    setIsOpen((prevIsCollapsed) => !prevIsCollapsed);
    event.preventDefault();
  };

  return (
    <div data-testid={id}>
      <div className="sm:py-spacing-s md:py-spacing-m">
        <button
          type="button"
          className={`text-black w-full text-left transition duration-300  flex items-center justify-between ${Styles.expandTitle}`}
          data-testid="accordion-toggle-btn"
          onClick={toggle}
        >
          <div className="sm:text-[20px] tablet:text-header-font-size-medium lg:text-l text-text-title sm:leading-custom-size-sm md:leading-custom-size-md lg:leading-custom-size-lg font-dmserif font-header-font">
            <p
              data-testid="paragaph-testid"
              className=" false"
              id="paragaph-test-id1"
            >
              {title}
            </p>
          </div>
          <div className="w-[24px] h-[24px]">
            {initShow ? (
              <ChevronUpIcon brand={brand} />
            ) : (
              <ChevronDownIcon brand={brand} />
            )}
          </div>
        </button>
      </div>
    </div>
  );
}
export default ExpandTitle;
